var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "300pt",
    height: "300pt",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 83.519531 191.40625 L 67.203125 62.171875 C 67.226563 62.191406 67.25 62.207031 67.273438 62.226563 C 77.777344 70.660156 93.941406 68.941406 109.496094 77.523438 C 123.34375 85.167969 137.128906 97.101563 163.664063 134.417969 C 190.199219 171.734375 196.941406 188.671875 199.617188 204.261719 C 202.617188 221.773438 195.6875 236.476563 200.203125 249.164063 C 200.214844 249.195313 200.222656 249.222656 200.230469 249.25 Z M 210.917969 240.753906 C 210.644531 227.695313 217.773438 215.734375 214.253906 194.382813 C 210.734375 173.035156 191.886719 146.152344 176.863281 125.03125 C 161.84375 103.90625 142.644531 77.277344 123.632813 66.941406 C 104.621094 56.605469 90.980469 59.414063 78.738281 54.867188 C 66.496094 50.324219 60.472656 37.378906 56.246094 40.382813 C 53.875 42.070313 54.335938 46.101563 57.058594 50.800781 L 75.238281 194.789063 L 77.605469 198.117188 L 207.644531 262.566406 C 211.1875 266.683594 214.84375 268.441406 217.214844 266.753906 C 221.4375 263.75 211.191406 253.808594 210.917969 240.753906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 111.769531 181.800781 L 115.304688 197.042969 L 79.585938 221.925781 L 73.9375 197.582031 L 52.800781 184.257813 L 88.519531 159.371094 L 101.757813 167.714844 L 197.8125 99.535156 L 183.890625 90.980469 L 243.351563 77.753906 L 211.332031 129.574219 L 207.824219 113.617188 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRange);
export default __webpack_public_path__ + "static/media/Range.ed066ee74eb5807023910404fe0b0fd9.svg";
export { ForwardRef as ReactComponent };